export default {
    inject: ['EventBus'],
    props: {
        ariaLabel: {
            type: String,
            required: false
        }
    },
    render(h) {
        const container = h(
            'button', {
                attrs: {
                    'aria-label': this.ariaLabel
                },
                on: {
                    click: (evt) => {
                        if(evt.target.hasAttribute('step-index')) {
                            this.EventBus.$emit('stepTrigger', evt.target.getAttribute('step-index'));
                        } else {
                            this.EventBus.$emit('stepTrigger');
                            // evt.target.setAttribute('disabled', 'disabled');
                        }
                    }
                }
            }, [this.$slots.default]
        );

        return container;
    }
};



// WEBPACK FOOTER //
// ./src/app/components/aha-transition-trigger.js